import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import NavLink from '../../../global/NavLink';

const Caret = styled.span`
  color: ${p => p.theme.color.textSecondary};
  margin: 0 10px 0 10px;
  display ${p => (p.show ? 'inline' : 'none')}
`;

const Crumb = styled(NavLink)`
  color: ${p => p.theme.color.textSecondary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 15px;
  font-weight: ${p => p.theme.fontWeight.regular};
  letter-spacing: 0.02px;
  text-transform: uppercase;

  &:hover {
    color: ${p => p.theme.color.primary};
  }
`;

const BreadCrumbs = ({ className, crumbs }) => (
  <div className={className}>
    {crumbs.map((crumb, index) => (
      <Crumb key={index} to={crumb.slug}>
        {crumb.name}
        <Caret show={index < crumbs.length - 1}>{'>'}</Caret>
      </Crumb>
    ))}
  </div>
);

BreadCrumbs.propTypes = {
  className: PropTypes.string,
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, slug: PropTypes.string })
  ).isRequired
};

export default BreadCrumbs;
